module.exports = __webpack_public_path__ + "static/media/medellin-17.415d66c0.jpg";